(function(){

function animate(container){
  const blocos = container.querySelectorAll('.ym-bloco');
  blocos.forEach(b=>b.classList.remove('show'));

  void container.offsetHeight;

  blocos.forEach((b,i)=>{
    setTimeout(()=>b.classList.add('show'), i*120);
  });
}

function init(){

  const wrapper = document.querySelector('.ym-wrapper');
  if(!wrapper) return;

  const tabs = wrapper.querySelectorAll('.ym-tab');
  const contents = wrapper.querySelectorAll('.ym-content');

  tabs.forEach(tab=>{
    tab.addEventListener('click', function(){

      tabs.forEach(t=>t.classList.remove('active'));
      contents.forEach(c=>c.classList.remove('active'));

      this.classList.add('active');

      const el = wrapper.querySelector(`[data-content="${this.dataset.tab}"]`);

      if(el){
        el.classList.add('active');
        animate(el);
      }

    });
  });

  /* GUIA */

  const guideTabs = wrapper.querySelectorAll('.ym-guide-tab');
  const guideContents = wrapper.querySelectorAll('.ym-guide-content');

  guideTabs.forEach(tab=>{
    tab.addEventListener('click', function(){

      guideTabs.forEach(t=>t.classList.remove('active'));
      guideContents.forEach(c=>c.classList.remove('active'));

      this.classList.add('active');

      const el = wrapper.querySelector(`[data-guide-content="${this.dataset.guide}"]`);
      if(el) el.classList.add('active');

    });
  });

  const active = wrapper.querySelector('.ym-content.active');
  if(active) animate(active);

}

document.addEventListener('DOMContentLoaded', init);

})();


/* =========================
   POPUP STEP-BY-STEP FINAL
========================= */

(function(){

let mode = "body";

const stepMap = {
  top: ["busto"],
  bottom: ["cintura","quadril"],
  body: ["busto","cintura","quadril"]
};

let steps = [];
let stepIndex = 0;

let data = {
  busto:null,
  cintura:null,
  quadril:null
};

const popup = document.getElementById("ym-popup");

/* GARANTE QUE NÃO BUGA AO CARREGAR */
if(popup){
  popup.classList.remove("active");
}

/* ========================= */

document.addEventListener("click", function(e){

  /* ABRIR POPUP */
  if(e.target.closest(".ym-discover-btn")){
    openPopup();
  }
  
  // STEP 1
  if(e.target.closest(".ym-choice")){

  mode =
    e.target.closest(".ym-choice").dataset.mode;

  steps = stepMap[mode];

  document.querySelector('[data-step="1"]').style.display = "none";
  document.querySelector('[data-step="2"]').style.display = "block";

  stepIndex = 0;

  render();
}

  /* FECHAR */
  if(e.target.closest(".ym-popup-close") || e.target.classList.contains("ym-popup-overlay")){
    closePopup();
  }

  /* PRÓXIMO */
  if(e.target.closest(".ym-next")){
    if(!validate()) return;

    save();
    stepIndex++;

    if(stepIndex < steps.length){
      render();
    } else {
      showResult();
    }
  }

/* RESTART */
if(e.target.closest(".ym-restart")){

  reset();

  document.querySelector('[data-step="1"]').style.display = "block";
  document.querySelector('[data-step="2"]').style.display = "none";
  document.querySelector('[data-step="3"]').style.display = "none";

}

});

/* =========================
   FUNÇÕES POPUP
========================= */

function openPopup(){

  if(!popup) return;

  popup.classList.add("active");
  document.body.style.overflow = "hidden";

  reset();

  document.querySelector('[data-step="1"]').style.display = "block";
  document.querySelector('[data-step="2"]').style.display = "none";
  document.querySelector('[data-step="3"]').style.display = "none";
}

function closePopup(){
  if(!popup) return;

  popup.classList.remove("active");
  document.body.style.overflow = "";
}

/* =========================
   RENDER
========================= */

function render(){

  const field = steps[stepIndex];
  const container = document.querySelector(".ym-inputs");
  const title = document.querySelector('[data-step="2"] .ym-step-title');

  if(!container || !title) return;

  let label = "";

  if(field === "busto") label = "Qual seu busto? (cm)";
  if(field === "cintura") label = "Qual sua cintura? (cm)";
  if(field === "quadril") label = "Qual seu quadril? (cm)";

  title.innerText = label;

  container.innerHTML = `
    <input type="number" class="ym-field" placeholder="Ex: 90">
    <span class="ym-error">Preencha corretamente</span>
  `;

  container.querySelector(".ym-field")
?.addEventListener("keydown", e => {

  if(e.key === "Enter"){
    e.preventDefault();
    document.querySelector(".ym-next")?.click();
  }

});

  setTimeout(()=>{
    document.querySelector(".ym-field")?.focus();
  },100);
}

/* =========================
   VALIDAÇÃO
========================= */

function validate(){

  const input = document.querySelector(".ym-field");
  const error = document.querySelector(".ym-error");

  if(!input || !error) return false;

  if(!input.value || input.value <= 0){
    input.classList.add("error");
    error.classList.add("active");
    return false;
  }

  input.classList.remove("error");
  error.classList.remove("active");

  return true;
}

/* =========================
   SAVE
========================= */

function save(){
  const input = document.querySelector(".ym-field");
  if(!input) return;

  data[steps[stepIndex]] = parseInt(input.value);
}

/* =========================
   RESULTADO
========================= */

function showResult(){

  let texto = "Seu tamanho ideal é:";

if(mode === "top"){
  texto = "Seu tamanho ideal para parte de cima é:";
}

if(mode === "bottom"){
  texto = "Seu tamanho ideal para parte de baixo é:";
}

if(mode === "body"){
  texto = "Seu tamanho ideal para corpo completo é:";
}

document.querySelector(".ym-result-title").innerText =
  texto;

let tabela = [];

if(mode === "top"){

  tabela = [
    { tamanho:"34", busto:82.5 },
    { tamanho:"36", busto:86 },
    { tamanho:"38", busto:90 },
    { tamanho:"40", busto:94 },
    { tamanho:"42", busto:98 }
  ];

}

if(mode === "bottom"){

  tabela = [
    { tamanho:"34", cintura:62.5, quadril:92.5 },
    { tamanho:"36", cintura:66, quadril:96 },
    { tamanho:"38", cintura:70, quadril:100 },
    { tamanho:"40", cintura:74, quadril:104 },
    { tamanho:"42", cintura:78, quadril:108 }
  ];

}

if(mode === "body"){

  tabela = [
    { tamanho:"P", busto:84, cintura:66, quadril:96 },
    { tamanho:"M", busto:88, cintura:70, quadril:100 },
    { tamanho:"G", busto:92, cintura:74, quadril:104 },

    { tamanho:"34", busto:82.5, cintura:62.5, quadril:92.5 },
    { tamanho:"36", busto:86, cintura:66, quadril:96 },
    { tamanho:"38", busto:90, cintura:70, quadril:100 },
    { tamanho:"40", busto:94, cintura:74, quadril:104 },
    { tamanho:"42", busto:98, cintura:78, quadril:108 }
  ];

}

  let menorErro = Infinity;
  let resultados = [];

  tabela.forEach(item => {

    let erro = 0;

    if(mode === "top"){

      erro =
        Math.abs(data.busto - item.busto);

    }

    if(mode === "bottom"){

      erro =
        Math.abs(data.cintura - item.cintura) +
        Math.abs(data.quadril - item.quadril);

    }

    if(mode === "body"){

      erro =
        Math.abs(data.busto - item.busto) +
        Math.abs(data.cintura - item.cintura) +
        Math.abs(data.quadril - item.quadril);

    }

    if(erro < menorErro){

      menorErro = erro;
      resultados = [item.tamanho];

    }else if(erro === menorErro){

      resultados.push(item.tamanho);

    }

  });

let principal = resultados[0];

const pares = {
  36: "P",
  38: "M",
  40: "G",
  P: "36",
  M: "38",
  G: "40"
};

if (
  (mode === "bottom" || mode === "body") &&
  resultados.length > 1
) {

  const equivalente =
    resultados.find(
      item =>
        item !== principal &&
        pares[principal] === item
    );

  if (equivalente) {
    principal =
      `${principal} <span class="ym-result-secondary">/ ${equivalente}</span>`;
  }

} else if (
  (mode === "bottom" || mode === "body") &&
  pares[principal]
) {

  principal =
    `${principal} <span class="ym-result-secondary">/ ${pares[principal]}</span>`;

}

let html = `
  <div class="ym-result-main">
    ${principal}
  </div>
`;

// fim

document.querySelector(".ym-result").innerHTML =
  html;

document.querySelector('[data-step="2"]').style.display =
  "none";

document.querySelector('[data-step="3"]').style.display =
  "block";
document.querySelector(".ym-result").innerHTML =
  html;
  document.querySelector('[data-step="2"]').style.display = "none";
  document.querySelector('[data-step="3"]').style.display = "block";
}

/* =========================
   RESET
========================= */

function reset(){

  stepIndex = 0;
  mode = "body";
  steps = [];

  data = {
    busto: null,
    cintura: null,
    quadril: null
  };

}

})();


/* =========================
   WHATSAPP (MANTIDO)
========================= */

document.addEventListener("click", function(e){

  const btn = e.target.closest(".ym-whatsapp-trigger");
  if(!btn) return;

  const overlay = document.getElementById("pw-overlay");
  const drawer = document.getElementById("pw-drawer");

  if(overlay && drawer){
    overlay.style.display = "block";
    drawer.classList.add("open");
  }

});